import React, {Fragment} from "react";
import ChannelCard from "../../Utilities/ChannelCard";
import logoZendesk from "../../../../../images/logos/logo_zendesk.svg";
import ZendeskSetupModal from "./ZendeskSetupModal";
import useZendeskSetup from "./useZendeskSetup";

export default function ZendeskProvider(){
    const { initiateZendeskSetup, zendeskSetupOpen, handleZendeskSetupClose, handleZendeskSetupOpen } = useZendeskSetup()

    return(
        <Fragment>
            <ChannelCard
                icon={logoZendesk}
                label={'Zendesk'}
                description={'Send personalized winback messages or resolve support tickets'}
                onClick={initiateZendeskSetup}
            />
            <ZendeskSetupModal
                open={zendeskSetupOpen}
                handleOpen={handleZendeskSetupOpen}
                handleClose={handleZendeskSetupClose}
            />
        </Fragment>
    )
}